<div class="bg-filter" style="margin-bottom: 24px;">
  <a class="close-icon" (click)="closeModal()" style="cursor: pointer;"><span class="material-icons">close</span></a>
  <div class="row px-40 py-1" style="padding-right: 60px;">
    <div class="col">
      <app-price-modal-filter (filtersSelects)="filtersChanged($event)" [vehicle]="vehicle"
        [isEvaluation]="isEvaluation"></app-price-modal-filter>
    </div>
  </div>
</div>
<div *ngIf="result">
  <div class="row px-40 py-1" style="margin-bottom: 24px;">
    <div class="col-12 col-xl-6 size-bar">
      <div class="p-0">
        <p class="text-center">
          <span class="title-compras">{{
              isBuyPrice ? "Compras realizadas " : "Repasses realizados "
            }}
          </span>
          <!-- <span class="title-qtd">
            {{ result.range.numVehicles }} veículos</span> -->
        </p>
        <div class="border-bar px-40 py-32" *ngIf="result.range.numVehicles > 0" style="height: 150px;">
          <app-price-gradient-bar [prices]="result.range">
          </app-price-gradient-bar>
        </div>
        <div class="border-bar px-40 py-32" *ngIf="result.range.numVehicles <= 0" style="height: 150px;">
          <div class="no-results">
            <div class="icon-container">
              <i class="app-icon-car-alt"></i>
            </div>
            <span>{{
              isBuyPrice
                  ? "Nenhuma compra realizada neste período"
                  : "Nenhum repasse realizado neste período"
              }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-xl-6 size-bar">
      <div class="p-0">
        <p class="text-center">
          <span class="title-compras">{{
            isBuyPrice ? "Compras não finalizadas " : "Repasses em aberto "
          }}</span>
          <!-- <span class="title-qtd">
            {{ result.notRange.numVehicles }} veículos</span> -->
        </p>
        <div class="border-bar px-40 py-32" *ngIf="result.notRange.numVehicles > 0" style="height: 150px;">
          <app-price-gradient-bar [prices]="result.notRange">
          </app-price-gradient-bar>
        </div>
        <div class="border-bar px-40 py-32" *ngIf="result.notRange.numVehicles <= 0" style="height: 150px;">
          <div class="no-results">
            <div class="icon-container">
              <i class="app-icon-car-alt"></i>
              <i class="material-icons">help</i>
            </div>

            <span>{{
              isBuyPrice
                ? "Nenhuma captação não finalizada nesse período"
                : "Nenhum repasse realizado neste período"
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row px-40 py-1" *ngIf="isBuyPrice && result.history?.length > 0">
    <div class="col">
      <span class="table-title">Histórico</span>
      <table id="tabela1" matSort (matSortChange)="sortData($event)" class="table">
        <tr class="table-header">
          <th mat-sort-header="vehicle">VEÍCULO</th>
          <th mat-sort-header="year" class="th-center">ANO</th>
          <th mat-sort-header="price" class="th-center">VALOR</th>
          <th mat-sort-header="date" class="th-center">DATA</th>
          <th mat-sort-header="status" class="th-center">STATUS</th>
        </tr>
        <tr class="table-body" *ngFor="let item of result.history">
          <td style="max-width: 57%;">
            <span>{{ item.make }} {{ item.model }}</span> <br />
            <span class="table-body-subtitle">{{ item.trim }}</span>
          </td>

          <td style="width: 12%; text-align: center;">
            {{ item.manufactureYear }}/{{ item.modelYear }}
          </td>
          <td style="width: 18%; text-align: center;">
            <div *ngIf="item.price">
              <span>R$ {{ item.price | number: "1.2-2" }}</span><br />
              <app-fipe-comparison-badge
                *ngIf="item.fipeDiff"
                variant="inline"
                cssClass="table-body-subtitle"
                [fipeDiff]="item.fipeDiff"
                [displayMode]="userInfo?.fipeComparisonMode"
              />
            </div>
            <span *ngIf="!item.price">
              Sem informação
            </span>
          </td>

          <td style="width: 13%; text-align: center;">
            {{ item.createdAt | date: "dd/MM/yyyy" }}
          </td>
          <td style="width: 15%; text-align: center; font-weight: bold;">
            <span>{{ item.bought ? "Comprado" : "Não finalizada" }}</span><br />
            <span class="table-body-subtitle" style="font-weight: normal;" *ngIf="item.boughtAt && item.bought">em
              {{ item.boughtAt | date: "dd/MM/yyyy" }}</span>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <div class="row px-40 py-1" *ngIf="!isBuyPrice && result.history?.length > 0">
    <div class="col">
      <span class="table-title">Histórico</span>
      <table id="tabela2" matSort (matSortChange)="sortData($event)" class="table">
        <tr class="table-header">
          <th mat-sort-header="vehicle">VEÍCULO</th>
          <th mat-sort-header="year" class="th-center">ANO</th>
          <th mat-sort-header="initialBid" class="th-center">LANCE INICIAL</th>
          <th mat-sort-header="lastBid" class="th-center">VENDIDO POR</th>
          <th mat-sort-header="margin" class="th-center">MARGEM</th>
          <th mat-sort-header="soldAt" class="th-center">DATA DA VENDA</th>
        </tr>
        <tr class="table-body" *ngFor="let item of result.history">
          <td style="max-width: 37%;">
            <span>{{ item.make }} {{ item.model }}</span> <br />
            <span class="table-body-subtitle">{{ item.trim }}</span>
          </td>
          <td style="width: 12%; text-align: center;">
            {{ item.manufactureYear }}/{{ item.modelYear }}
          </td>
          <td style="width: 18%; text-align: center;">
            <div *ngIf="item.initialBid">
              <span>R$ {{ item.initialBid | number: "1.0-0" }}</span><br />
              <app-fipe-comparison-badge
                variant="inline"
                cssClass="table-body-subtitle"
                [fipeDiff]="item.fipeDiffInitialBid"
                [displayMode]="userInfo?.fipeComparisonMode"
              />
            </div>
            <span *ngIf="!item.initialBid">
              Sem informação
            </span>
          </td>
          <td style="width: 18%; text-align: center;" [ngClass]="{'traco': !item.lastBid}">
            <div *ngIf="item.lastBid">
              <span style="font-weight: bold;">R$ {{ item.lastBid | number: "1.0-0" }}</span>
            </div>
            <span *ngIf="!item.lastBid">
              --
            </span>
          </td>
          <td style="width: 8%; text-align: center;" [ngClass]="{'traco': !item.margin}">
            <div *ngIf="item.margin">
              <span>{{ item.margin | percent }}</span>
            </div>
            <span *ngIf="!item.margin">
              --
            </span>
          </td>
          <td style="width: 13%; text-align: center;" [ngClass]="{'traco': !item.soldAt}">
            <div *ngIf="item.soldAt">
              <span>{{ item.soldAt | date: "dd/MM/yyyy" }}</span>
            </div>
            <span *ngIf="!item.soldAt">
              --
            </span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>